import connectionProxy from './connectionProxy'
const redirect_url = process.env.REACT_APP_RESET_PASSWORD_REDIRECT_URL

export const authenticate = user => {
  return connectionProxy.http.post(`/auth/sign_in`, user)
}

export const logout = ({ uid, accessToken }) => {
  return connectionProxy.http.delete(`/auth/sign_out`,  {
    uid,
    accessToken
  })
}

export const registerNewPassword = ({ password = '', password_confirmation = '' }) => {
  return connectionProxy.http.put(`/auth/password`,  {
    password,
    password_confirmation
  })
}

export const recoverPassword = ({ email }) => {
  return connectionProxy.http.post(`/auth/password`,  {
    email,
    redirect_url
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js